var emjcof = {
    bili: {
        text: [
            { value: "baiyan", det: ["1800ms", "steps(45)", "translateY(-1408px)", "1440px"] },
            {
                value: "fadai", det: ["1080ms",
                    "steps(27)",
                    "translateY(-832px)",
                    "864px"]
            },
            {
                value: "koubi", det: ["1200ms",
                    "steps(30)",
                    "translateY(-928px)",
                    "960px"]
            },
            {
                value: "qinqin", det: ["280ms",
                    "steps(7)",
                    "translateY(-192px)",
                    "224px"]
            },
            {
                value: "weiqu", det: ["800ms",
                    "steps(20)",
                    "translateY(-608px)",
                    "640px"]
            },















            {
                value: "bishi", det: ["360ms",
                    "steps(9)",
                    "translateY(-256px)",
                    "288px"]
            },
            {
                value: "fanu", det: ["1320ms",
                    "steps(33)",
                    "translateY(-1024px)",
                    "1056px"]
            },
            {
                value: "kun", det: ["1760ms",
                    "steps(44)",
                    "translateY(-1376px)",
                    "1408px"]
            },
            {
                value: "se", det: ["400ms",
                    "steps(10)",
                    "translateY(-288px)",
                    "320px"]
            },
            {
                value: "weixiao", det: ["800ms",
                    "steps(20)",
                    "translateY(-608px)",
                    "640px"]
            },
            {
                value: "bizui", det: ["1240ms",
                    "steps(31)",
                    "translateY(-960px)",
                    "992px"]
            },
            {
                value: "ganga", det: ["1520ms",
                    "steps(38)",
                    "translateY(-1184px)",
                    "1216px"]
            },
            {
                value: "lengmo", det: ["40ms",
                    "steps(1)",
                    "translateY(-0px)",
                    "32px"]
            },
            {
                value: "shengbing", det: ["1400ms",
                    "steps(35)",
                    "translateY(-1088px)",
                    "1120px"]
            },
            {
                value: "wunai", det: ["920ms",
                    "steps(23)",
                    "translateY(-704px)",
                    "736px"]
            },
            {
                value: "chan", det: ["1600ms",
                    "steps(40)",
                    "translateY(-1248px)",
                    "1280px"]
            },
            {
                value: "guilian", det: ["40ms",
                    "steps(1)",
                    "translateY(-0px)",
                    "32px"]
            },
















            {
                value: "liubixue", det: ["1400ms",
                    "steps(35)",
                    "translateY(-1088px)",
                    "1120px"]
            },
            {
                value: "shengqi", det: ["440ms",
                    "steps(11)",
                    "translateY(-320px)",
                    "352px"]
            },
            {
                value: "xiaoku", det: ["600ms",
                    "steps(15)",
                    "translateY(-448px)",
                    "480px"]
            },
            {
                value: "daku", det: ["320ms",
                    "steps(8)",
                    "translateY(-224px)",
                    "256px"]
            },
            {
                value: "guzhang", det: [
                    "680ms",
                    "steps(17)",
                    "translateY(-512px)",
                    "544px"]
            },
            {
                value: "liuhan", det: ["1080ms",
                    "steps(27)",
                    "translateY(-832px)",
                    "864px"]
            },
            {
                value: "shuizhao", det: ["960ms",
                    "steps(24)",
                    "translateY(-736px)",
                    "768px"]
            },
            {
                value: "xieyanxiao", det: ["320ms",
                    "steps(8)",
                    "translateY(-224px)",
                    "256px"]
            },
            {
                value: "dalao", det: ["1320ms",
                    "steps(33)",
                    "translateY(-1024px)",
                    "1056px"]
            },
            {
                value: "haixiu", det: [
                    "1240ms",
                    "steps(31)",
                    "translateY(-960px)",
                    "992px"]
            },
            {
                value: "liulei", det: ["40ms",
                    "steps(1)",
                    "translateY(-0px)",
                    "32px"]
            },
            {
                value: "sikao", det: ["1440ms",
                    "steps(36)",
                    "translateY(-1120px)",
                    "1152px"]
            },
            {
                value: "yiwen", det: ["840ms",
                    "steps(21)",
                    "translateY(-640px)",
                    "672px"]
            },
            {
                value: "dalian", det: ["1480ms",
                    "steps(37)",
                    "translateY(-1152px)",
                    "1184px"]
            },
            {
                value: "heirenwenhao", det: [
                    "1040ms",
                    "steps(26)",
                    "translateY(-800px)",
                    "832px"]
            },
            {
                value: "miantian", det: ["1120ms",
                    "steps(28)",
                    "translateY(-864px)",
                    "896px"]
            },
            {
                value: "tiaokan", det: ["40ms",
                    "steps(1)",
                    "translateY(-0px)",
                    "32px"]
            },
            {
                value: "yun", det: ["480ms",
                    "steps(12)",
                    "translateY(-352px)",
                    "384px"]
            },
            {
                value: "dianzan", det: ["800ms",
                    "steps(20)",
                    "translateY(-608px)",
                    "640px"]
            },
            {
                value: "huaixiao", det: ["1240ms",
                    "steps(31)",
                    "translateY(-960px)",
                    "992px"]
            },
            {
                value: "mudengkoudai", det: ["40ms",
                    "steps(1)",
                    "translateY(-0px)",
                    "32px"]
            },
            {
                value: "tiaopi", det: ["2000ms",
                    "steps(50)",
                    "translateY(-1568px)",
                    "1600px"]
            },
            {
                value: "zaijian", det: ["960ms",
                    "steps(24)",
                    "translateY(-736px)",
                    "768px"]
            },
            {
                value: "doge", det: ["800ms",
                    "steps(20)",
                    "translateY(-608px)",
                    "640px"]
            },
            {
                value: "jingxia", det: ["1280ms",
                    "steps(32)",
                    "translateY(-992px)",
                    "1024px"]
            },


            {
                value: "nanguo", det: ["1120ms",
                    "steps(28)",
                    "translateY(-864px)",
                    "896px"]
            },
            {
                value: "touxiao", det: ["240ms",
                    "steps(6)",
                    "translateY(-160px)",
                    "192px"]
            },
            {
                value: "zhoumei", det: ["40ms",
                    "steps(1)",
                    "translateY(-0px)",
                    "32px"]
            },
            {
                value: "facai", det: ["1200ms",
                    "steps(30)",
                    "translateY(-928px)",
                    "960px"]
            },
            {
                value: "keai", det: ["680ms",
                    "steps(17)",
                    "translateY(-512px)",
                    "544px"]
            },
            {
                value: "outu", det: [
                    "1680ms",
                    "steps(42)",
                    "translateY(-1312px)",
                    "1344px"]
            },
            {
                value: "tuxue", det: ["320ms",
                    "steps(8)",
                    "translateY(-224px)",
                    "256px"]
            },
            {
                value: "zhuakuang", det: ["760ms",
                    "steps(19)",
                    "translateY(-576px)",
                    "608px"]
            }
        ],
        host: "https://cdn.jsdelivr.net/gh/moezx/cdn@2.9.4/img/bili/"
    },
    tieba: {
        text: [
            "icon_tongue",
            "icon_theblackline",
            "icon_tear",
            "icon_surprised",
            "icon_surprised2",
            "icon_spray",
            "icon_spit",
            "icon_smilingeyes",
            "icon_shui",
            "icon_shame",
            "icon_se",
            "icon_rmb",
            "icon_reluctantly",
            "icon_rbq",
            "icon_niconiconit",
            "icon_niconiconi",
            "icon_niconiconi_t",
            "icon_naive",
            "icon_ku",
            "icon_huaji",
            "icon_hu",
            "icon_han",
            "icon_haha",
            "icon_good",
            "icon_doubt",
            "icon_britan",
            "icon_bbd",
            "icon_awesome",
            "icon_anger",
            "icon_aa",
            "icon_Happy"
        ],
        host: "https://cdn.jsdelivr.net/gh/moezx/cdn@3.1.9/img/Sakura/images/smilies/"
    }
}

export default emjcof